import React from "react";
import "./Banner.css";

const Banner = ({ image, alt = "banner" }) => {
  return (
    <div className="banner-container">
      <img src={image} alt={alt} className="banner-img" />
    </div>
  );
};

export default Banner;